import React, { useState, useEffect, useContext } from 'react';
import cl from './Finances.module.css'
import Id from "../../../../assets/Icon/Id";
import Mobile from "../../../../assets/Icon/Mobile";
import At from "../../../../assets/Icon/At";
import Vin from "../../../../assets/Icon/Vin";
import Container from "../../../../assets/Icon/Container";
import Auction from "../../../../assets/Icon/Auction";
import Ship from "../../../../assets/Icon/Ship";   
import AutowiniInvoice from '../Invoice/AutowiniInvoice';
import Contract from '../Contract/Contract'; 
import InsuranceSupplement from '../Contract/InsuranceSupplement';
import PrivacyPolicy from '../Contract/PrivacyPolicy';
import ContractDeposit from '../Contract/Deposit'; 
import Flag from '../../../UI/Flag/Flag';
import { AppContext } from '../../../../providers/appProvider'; 
import { baseFileURL } from '../../../../Api'; 
import LondonUnderWriters from '../LondonUnderwriters/Underwriters';  
import Photo from "../../../../assets/Icon/Photo";
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
 

const CarItem = ({ carItem, carService, statuses }) => {

    const { t, i18n } = useTranslation();
    const lang = i18n.language;     

    const formatDate = (dateString) => {
        if (!dateString) {
            return "";
        }

        const purchasedAtDate = new Date(dateString);

        if (isNaN(purchasedAtDate.getTime())) {
            //console.error("Invalid date provided:", dateString);
            return "";
        }

        const months = [
            t('Jan'), t('Feb'), t('Mar'), t('Apr'), t('May'), t('Jun'),
            t('Jul'), t('Aug'), t('Sep'), t('Oct'), t('Nov'), t('Dec')
        ];

        const monthIndex = purchasedAtDate.getMonth();
        if (typeof monthIndex !== "number" || monthIndex < 0 || monthIndex > 11) {
            return "";
        }

        const day = purchasedAtDate.getDate();
        const month = months[monthIndex];
        const year = purchasedAtDate.getFullYear();

        return `${day} ${month} ${year}`;
    };
 
    const { app } = useContext(AppContext);
    const [car, setCar] = useState(carItem) 
    const prices = carService.calculatePrice(car); 

    var clientPrice = prices.clientPrice;
    var percent = prices.clientPercent;

  

    useEffect(() => {
        setCar(carItem)
    }, [carItem]);


  
  
 

    let doneclass = cl.redFin
    const tdStyles = cl.redTable;
    let doneClientclass = cl.redFin
 

    if (car.company_debt <= 0) {
        doneclass = cl.greenFin
    } else {
        doneclass = cl.redFin
    }

   

    if (car.client_debt <= 0) {
        doneClientclass = cl.greenFin
    } else {
        doneClientclass = cl.redFin
    }

    if (car.pwin < 0) {
        doneClientclass = cl.redFin
    }  

 

 
 
 
    /* services */
     var services = [
        { value: 1, label: t('PurchaseTransportation') },
        { value: 2, label: t('Transportation') },
        { value: 3, label: t('Purchase') },
        { value: 4, label: t('Deposit') },
        { value: 5, label: t('Inspection') },  
    ];
    /* services */

    /* insurance */
    const insurances = [
        { id: 1, name: t('MustBeInsured'), color: "#ccc" },
        { id: 2, name: t('Insured'), color: "#16a085" },
        { id: 3, name: t('NotInsured'), color: "#d80228" },
    ];

    const insurancesOptions = insurances.map((status) => ({ value: status.id, label: status.name, color: status.color }));
    /* insurance */




    /* statuses */

    const statusLabels = {
            2: { ka: 'ნაყიდია',                en: 'Purchased',             ru: 'Куплено' },
            3: { ka: 'მიყვანილია საწყობში',    en: 'Delivered to warehouse',ru: 'Доставлено на склад' },
            4: { ka: 'ჩატვირთულია',             en: 'Loaded',                ru: 'Загружено' },
            5: { ka: 'დასრულებულია',           en: 'Completed',             ru: 'Завершено' },
            6: { ka: 'საბუთი გაცემულია',       en: 'Documents issued',      ru: 'Документы выданы' },
            7: { ka: 'შემოვიდა პორტში',       en: 'Arrived at port',       ru: 'Прибыло в порт' },
            1: { ka: 'ინვოისი გამოწერილია',    en: 'Invoice issued',        ru: 'Счёт выставлен' },
            8: { ka: 'თანხის უკან დაბრუნება',  en: 'Refunded',              ru: 'Возврат средств' },
            9: { ka: 'Ჩანაცვლდა',             en: 'Replaced',              ru: 'Замена' },
           10: { ka: 'რელისტი',             en: 'Relist',              ru: 'Релист' },
           11: { ka: 'არ რეალიზდა',             en: 'Not Realized',              ru: 'Не реализовано' },

        };

        const StatusOptions = statuses.map(status => ({
        value: status.id,
        label: statusLabels[status.id]?.[lang] ?? status.name,
        color: status.color,
        }));
 
  
 


        const imageSources = [
            car.images_obj?.buy?.[0],
            car.images_obj?.loading?.[0],
            car.images_obj?.arrival?.[0]
        ];

        const firstAvailableImage = imageSources.find(Boolean);

        let mainImage;
        if (firstAvailableImage) {
            mainImage = <img src={baseFileURL + firstAvailableImage} alt="Car" />;
        } else {
            mainImage = <Photo />;
        }
        
  
        return <div>
            <div className={cl.flexList}>
                <div className={cl.item}>
                    <Link to={'/dealer/car/' + car.id} className={cl.Car}>
                        <div className={cl.incar}>
 
                             <div className={ cl.imageBox } > 
                                <div className={cl.imgCar} >
                                    {mainImage}
                                </div> 
                            </div> 

                            <div className={cl.carDesc}>
                                <div className={cl.carName}>
                                    {car.prod_year && car.prod_year} {car.maker && car.maker.name} {car.model && car.model.name}
                                </div>
                                <div className={cl.carDetail}>
                                    <ul>
                                        <li className={cl.copied + ' ' + cl.upcase}><Vin />{car.vin}</li>
                                        <li>{formatDate(car.purchased_at)}</li>

                                    </ul>
                                    <ul>
                                        <li>{car.website.name}</li>
                                        <li> <Auction />{car.lot}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </Link>

                    <Link to={'/dealer/car/' + car.id} className={cl.client}>
                        <div className={cl.clientDesc}>
                            <div className={cl.clientName}>
                                {car.client?.firstname} {car.client?.lastname}
                            </div>
                            <div className={cl.clientDetail}>
                                <ul>
                                    <li><Mobile />{car.client?.mobile}</li>
                                    <li><Id />{car.client?.personal}</li>
                                    <li><At />{car.client?.email}</li>
                                </ul>
                            </div>
                        </div>

                    </Link>

                    <Link to={'/dealer/car/' + car.id} className={cl.tranBox}>

                        <div className={cl.transport}>

                            <div className={cl.locationSender}>
                                {car.transport_price && car.transport_price.location_country ? (
                                    <Flag countryCode={car.transport_price.location_country.code}> </Flag>
                                ) : (
                                    ''
                                )}
                            </div>

                            <div className={cl.tranDesc} >
                                <ul>
                                    {car.marine_line && car.marine_line.name &&
                                        <li><Ship />{car.marine_line.name}</li>}

                                    {car.container_number &&
                                        <li><Container />{car.container_number}</li>}

                                </ul>
                                <div className={cl.line}></div>
                                <ul className={cl.arrauvul}>
                                    <li>{car.sender_at ? formatDate(car.sender_at) : ''}</li>
                                    <li>{car.reciever_at ? formatDate(car.reciever_at) : ''}</li>

                                </ul>
                            </div>

                            <div className={cl.locationReciever}>
                                <Flag countryCode={car.reciever_country && car.reciever_country.code}> </Flag>
                            </div>
                        </div>
 
                        <div className={cl.billingBox} style={{ padding: '6px 8px', display: 'flex', flexDirection: 'column', alignItems: 'stretch', gap: 0, width: '100%', height: '100%' }}> 
                            <div style={{ display: 'flex', flexDirection: 'row', width: '100%',justifyContent: 'space-between'}}> 
                                    {app.hasPermission("INSURANCE_SHOW") &&
                                        <>
                                            {insurancesOptions.map((option) => (
                                                <>
                                                    {option.value === car.insurance &&
                                                        <div key={option.value} style={{ backgroundColor: '#fff', display: 'flex', alignItems: 'center', border: '1px solid var(--border-color)', borderRadius: 5, fontSize: '12px', padding: '1px 3px', height: 22 }}  >
                                                            <div style={{ background: option.color, borderRadius: 50, content: ' ', display: 'block', marginRight: 4, height: 10, width: 10 }}></div>
                                                            {option.value === car.insurance ? `${option.label}` : option.label}
                                                        </div>
                                                    }
                                                </>
                                            ))}
                                        </> 
                                    }
    
                                    {app.hasPermission("STATUS_SHOW") &&
                                        <> 
                                        {StatusOptions.map((option) => (
                                            <>
                                                {option.value === car.status.id &&
                                                    <div   key={option.value} style={{ whiteSpace: 'nowrap', backgroundColor: '#fff', display: 'flex', alignItems: 'center', border: '1px solid var(--border-color)', borderRadius: 5, fontSize: '12px', padding: '1px 3px', height: 22 }}  >
                                                        <div style={{  background: option.color, borderRadius: 50, content: ' ', display: 'block', marginRight: 4, height: 10, width: 10 }}></div>
                                                        {option.value === car.status.id ? `${option.label}` : option.label}
                                                    </div>
                                                }
                                            </>
                                        ))} 
                                        </>
                                    } 

                            </div>
  
                                        {services.map((option) => (
                                            <>
                                                {option.value === car.service &&
                                                    <div   key={option.value} style={{ whiteSpace: 'nowrap', border: '1px solid var(--border-color)', borderRadius: 5, fontSize: '12px', padding: '1px 3px', height: 22 }}  >
                                                        {option.value === car.service ? `${option.label}` : option.label}
                                                    </div>
                                                }
                                            </>
                                        ))} 

                                           
                            

                        </div>

                    </Link>

                    <div className={cl.salerFinance}>

                        <div className={cl.priceValueB + ' ' + cl.centerBorder} style={{ width: '50%', maxWidth: '50%', minWidth: '50%' }}>

                            {app.hasPermission("CLIENT_PRICE_SHOW") &&
                                <Link to={'/dealer/car/' + car.id} className={cl.finance} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div className={cl.financeBox + ' ' + cl.blueFin}    >
                                        <div className={cl.financeDesc + ' nonetable'}>
                                            {t('Client')}
                                        </div>
                                        <div className={cl.financeValue}> 
                                            {(5 === car.website.id) ? 
                                                (car.client_deposit !== 0 ? car.client_deposit : ' ')
                                                :
                                                (car.total_client_price !== 0 ? car.total_client_price : ' ')
                                            }
                                        </div>
                                    </div>
                                </Link>  
                            }
 
                            {app.hasPermission("CLIENT_PAID_SHOW") &&
                                <Link to={'/dealer/car/' + car.id} className={cl.financeBox }   >
                                    <div className={cl.financeDesc + ' nonetable '}>  { t('Paid')}  </div>
                                    <div className={cl.financeValue}> 
                                        {car.total_client_paid}
                                    </div>
                                </Link>
                            }

                            {app.hasPermission("CLIENT_DEBT_SHOW") &&
                                <Link to={'/dealer/car/' + car.id} className={cl.financeBox + ' ' + doneClientclass}   >
                                    <div className={cl.financeDesc}>{t('Debt')} </div>
                                    <div className={cl.financeValue}> {car.client_debt}</div>
                                </Link>
                            }

                            {baseFileURL === 'https://finance.automoby.ge' ? 
                                ((car.client_price_fund * car.client_percent_fund) / 100 > 0 ?
                                            car.fund_accept == 1 ?
                                                <AutowiniInvoice  greenStyle={true} carItem={car} discountAccept={car.discount_accept}  websiteItem={car.website} clientItem={car.client} />
                                            :
                                                ''
                                            :
                                            <AutowiniInvoice greenStyle={true} carItem={car} discountAccept={car.discount_accept}  websiteItem={car.website} clientItem={car.client} />)
                                        :
                                        ((car.client_price_fund * car.client_percent_fund) / 100 > 0 ?
                                        car.fund_accept == 1 ?
                                            <AutowiniInvoice greenStyle={true} carItem={car} discountAccept={car.discount_accept}  websiteItem={car.website} clientItem={car.client} />
                                        :
                                            ''
                                        :
                                        <AutowiniInvoice greenStyle={true} carItem={car} discountAccept={car.discount_accept}  websiteItem={car.website} clientItem={car.client} />)
                                    }

                        </div>



                        <div className={cl.priceValueB} style={{ width: '50%', maxWidth: '50%', minWidth: '50%', }}>
                            {car.website.id === 5 ? <ContractDeposit carItem={car} /> : <Contract carItem={car} />}
                            <LondonUnderWriters carItem={car} />
                            <InsuranceSupplement carItem={car} />
                            <PrivacyPolicy carItem={car} />
                        </div>


                    </div>

                    <Link to={'/dealer/car/' + car.id}  className={cl.Finances}> 
                        <div className={cl.footerbtnio}> 
                            <div to={'/dealer/car/' + car.id} className={cl.navItemBtn}  >
                                {car.id}{car.lot !== undefined ? '/' + car.lot : ''}
                            </div> 
                        </div> 
                        <div  className={cl.footerbtnio} > 

                            
                
                        </div>

                    </Link>
                </div>
            </div>
 
        </div>;
 

}

export default CarItem;